import { ReactHookFormErrorMessage } from "components/base/ErrorFieldMessage";
import { CustomNumberMutipleInputWithUnit, CustomTitleLabel } from "components/earning/CustomBaseComponments";
import React from "react";
import { useFormContext } from "react-hook-form";

const ReactHookFormNumberMutipleInputWithUnit = ({
  title = "",
  tips = "",
  firstValueFieldName,
  secondValueFieldName,
  errorId,
  numberTitle,
  per,
  unit,
  disabled,
  useDefaultValue,
}) => {
  const { setValue, watch, formState: { errors } } = useFormContext();
  const firstValue = watch(firstValueFieldName) || ""
  const secondValue = watch(secondValueFieldName) || ""
  return (<>
    {title && <CustomTitleLabel title={title} />}
    {tips && <label className="tips-message">
      {tips}
    </label>}
    <CustomNumberMutipleInputWithUnit
      numberTitle={numberTitle}
      disabled={disabled}
      useDefaultValue={useDefaultValue}
      firstDefaultValue={firstValue}
      setFirstValue={(value) => {
        setValue(firstValueFieldName, value, { shouldDirty: true });
      }}
      secondDefaultValue={secondValue}
      setSecondValue={(value) => {
        setValue(secondValueFieldName, value, { shouldDirty: true });
      }}
      per={per}
      unit={unit}
    />
    {errorId && <ReactHookFormErrorMessage errors={errors} id={errorId} />}
  </>
  )
}

export default ReactHookFormNumberMutipleInputWithUnit;